import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackbarErrorComponent } from './snackbar-error/snackbar-error.component';
import { SnackbarSuccessComponent } from './snackbar-success/snackbar-success.component';
import { SnackbarWarningComponent } from './snackbar-warning/snackbar-warning.component';
import { SnackbarErrorModule } from './snackbar-error/snackbar-error.module';
import { SnackbarActionCloseComponent } from './snackbar-action-close/snackbar-action-close.component';



@NgModule({
	declarations: [
		// SnackbarErrorComponent,
		SnackbarSuccessComponent,
		SnackbarWarningComponent,
  		SnackbarActionCloseComponent,
	],
	imports: [
		MatButtonModule,
		MatIconModule,
		SnackbarErrorModule,
	],
	exports: [
		MatSnackBarModule
	]
})
export class CustomSnackbarModule { }
